<template>
    <section>
        <ul id="blog">
            <li v-for="b in blog" class="screen-transition" @click="select(b.blog_id_enc, $event)">
                <div class="created_at">{{ b.date }}</div>
                <div class="blog-title">{{ b.title }}</div>
                <img src="/image/icons/next.png">
            </li>
        </ul>
        <div v-if="showButton">
            <a class="button btn btn-dark" role="button" aria-pressed="true" @click="getBlog()" style="color: white">{{ characters.load_more }}</a>
        </div>
    </section>
</template>

<script>
    export default {
        name: "blog",
        props: ['get_blog_number', 'json_characters'],
        mounted() {
            this.getBlog();
            this.characters = JSON.parse(this.json_characters);
        },
        data: function () {
            return {
                blog: [],
                showButton: true,
                characters: Object,
            }
        },
        methods: {
            select: function (s, event) {
                console.log(s);
                if (s) {
                    const id = String(s);
                    location.href = `/blog/detail/${id}`;
                }
            },
            getBlog: function () {
                axios.default
                    .get('/blog/list?length=' + this.blog.length)
                    .then(response => {
                        if(response.data.length<this.get_blog_number) {
                            this.showButton = false;
                        }
                        if(this.blog.length == 0) {
                            this.blog = response.data;
                        } else {
                            this.blog = this.blog.concat(response.data);
                        }
                    });
            }
        }
    }
</script>

<style scoped>

</style>
